<template>
  <v-container v-if="service && service.mode == 'common'" grid-list-xl class="service-container">
    <Banner v-if="!isLoggedIn"></Banner>
    <v-row class="ml-3 ">
      <div class='headline'>{{ service.name }}</div>
    </v-row>
    <v-row>
      <v-flex>
        <v-form v-model="valid" lazy-validation>
          <account-selector :accounts="userAccounts" :selected-account.sync="selectedAccount" :search-input.sync="searchQuery" :searchQueryProp.sync="searchQuery" @update:selected-account="submit" />
        </v-form>
      </v-flex>
    </v-row>
    <v-layout wrap>
      <v-flex xs12 md9 lg8>
        <request-dialog v-model="searchDialog" message="Выполняется запрос..." />
      </v-flex>
    </v-layout>
    <component v-bind:is="currentServiceComponent" v-if="accountData || (service.workingWOConn && noAccountData)" :account-info="accountInfo"></component>
    <stub-page v-else-if="!service.workingWOConn && noAccountData" header="Ошибка при получении информации" message="Не удалось получить информацию о лицевом счёте. Попробуйте повторить запрос позднее." />
  </v-container>
  <v-container v-else-if="service.mode != 'common'" grid-list-xl class="service-container">
    <v-row class="ml-3">
      <div class='headline'>{{ service.name }}</div>
    </v-row>
    <component v-bind:is="currentServiceComponent" class='mt-9'></component>
  </v-container>
  <stub-page v-else header="Услуга не найдена" message="Такой услуги нет. Попробуйте вернуться к списку услуг." />
</template>
<script>
import { mapGetters } from 'vuex'
import { cleanNumber } from '@/utils'

export default {
  name: 'Service',

  components: {
    PersonalAccount: () => import(
      /* webpackChunkName: "service" */
      '@/components/account/PersonalAccount'
    ),
    MeterData: () => import(
      /* webpackChunkName: "service" */
      '@/components/account/MeterData'
    ),
    AddressF: () => import(
      /* webpackChunkName: "service" */
      '@/components/account/AddressF'
    ),
    Bills: () => import(
      /* webpackChunkName: "service" */
      '@/components/account/Bills'
    ),
    Reports: () => import(
      /* webpackChunkName: "service" */
      '@/components/account/Reports'
    ),
    Payment: () => import(
      /* webpackChunkName: "service" */
      '@/components/account/Payment'
    ),
    PaymentSber: () => import(
      /* webpackChunkName: "service" */
      '@/components/account/PaymentSber'
    ),
    PaymentReport: () => import(
      /* webpackChunkName: "service" */
      '@/components/operations/PaymentReport'
    ),
    ParsePayments: () => import(
      /* webpackChunkName: "service" */
      '@/components/operations/ParsePayments'
    ),
    InfoFIAS: () => import(
      /* webpackChunkName: "service" */
      '@/components/operations/InfoFIAS'
    ),
    Banner: () => import(
      /* webpackChunkName: "service" */
      '@/components/base/Banner'
    )
  },

  props: {
    id: {
      type: Number,
      default: undefined
    },
    account: {
      type: String,
      default: undefined
    }
  },

  data: () => ({
    searchDialog: false,
    searchQuery: null,
    valid: true,
    selectedAccount: null,
    noAccountData: false,
    accountInfo: null
  }),

  computed: {
    ...mapGetters({
      accountData: 'account/accountData',
      isLoggedIn: 'user/isAuthenticated',
      userAccounts: 'user/userAccounts',
      services: 'common/services'
    }),

    service: function() {
      const vm = this
      return this.services.find(s => s.id === vm.id)
    },

    currentServiceComponent: function() {
      return this.service.component
    }
  },

  created: function() {
    this.debouncedSubmit = this._.debounce(
      async function(accountNumber) {
        this.noAccountData = false
        await this.$store.dispatch('account/resetAccountData')
        this.searchDialog = true
        try {
          const resp = await this.$api.Account.getAccountInfo(cleanNumber(accountNumber))
          if (resp.data.address != null) {
            await this.$store.dispatch('account/setAccountData', resp.data)
            this.$store.dispatch('account/setSelectedAccount', accountNumber)
          } else {
            this.noAccountData = true
          }
          this.accountInfo = resp.data
          this.searchDialog = false
        } catch (e) {
          this.searchDialog = false
          const err = e
          let error = ''
          if (err.response.status === 404) error = 'Аккаунт с таким лицевым счётом не найден'
          else error = 'Во время выполнения запроса произошла ошибка'
          await this.$store.dispatch('notification/setSystemNotification', { message: error, type: 'error' })
          console.error(e)
        }
      },
      500, { 'leading': true, 'trailing': false })
    if (this.account != undefined) {
      this.searchQuery = this.account
      this.selectedAccount = this.account
      this.submit()
    }
  },

  methods: {
    async submit() {
      if (this.selectedAccount) {
        await this.debouncedSubmit(this.selectedAccount)
      }
    }
  }
}

</script>
<style scoped>
.centered-text {
  text-align: center;
  margin: 0 10px 0 10px;
}

.banner-img {
  height: 130px;
}

@media (max-width: 1000px) {
  .banner-img {
    height: 200px;
  }

  .service-container {
    padding: 0 !important;
  }
}

.service-container {
  margin-top: -22px;
  padding-top: 0 !important;
}
</style>